import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from 'antd';

JsonString.propTypes = {
  text: PropTypes.string.isRequired,
};
const AiAnswerWithCode = React.lazy(() => import("./AiAnswerWithCode"));
function JsonString(props) {
  return <Typography.Text className="render-line-breaks" code>{props.text}</Typography.Text>
  // return <AiAnswerWithCode text={`\`\`\`${props.text}\`\`\``} />
}

export default JsonString;
